// extracted by mini-css-extract-plugin
export var date = "post-card-module--date--5cc99";
export var excerpt = "post-card-module--excerpt--03291";
export var image = "post-card-module--image--032ee";
export var imagePlaceholder = "post-card-module--imagePlaceholder--3cbdb";
export var imagePlaceholderIcon = "post-card-module--imagePlaceholderIcon--dd19f";
export var taxonomies = "post-card-module--taxonomies--5e1af";
export var taxonomy = "post-card-module--taxonomy--a4959";
export var title = "post-card-module--title--28b54";